var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PresentacionDraftDetailView',{attrs:{"path":"draft","hideHistory":"","draft":"","action-buttons-prefix":"PresentacionDraftActionButtons"}})}
var staticRenderFns = []

export { render, staticRenderFns }